import React from 'react'
import { useDispatch } from 'react-redux'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { Button, ExternalLinkButton, If } from 'src/Components'
import { toggleYlopoOptInModal } from 'src/actions/ylopo'

const propTypes = {
  clientHasOptedIn: PropTypes.bool,
  className: PropTypes.string,
  ylopoListingsUrl: PropTypes.string.isRequired,
  children: PropTypes.any
}

const YlopoListingsButton = ({
  children,
  clientHasOptedIn,
  className,
  ylopoListingsUrl
}) => {
  const dispatch = useDispatch()

  return (
    <>
      <If condition={clientHasOptedIn}>
        <ExternalLinkButton
          className={classnames(className)}
          data-qa='ylopoListingsButton'
          href={ylopoListingsUrl}
        >
          {children}
        </ExternalLinkButton>
      </If>
      <If condition={!clientHasOptedIn}>
        <Button
          className={classnames(className)}
          onClick={() => dispatch(toggleYlopoOptInModal(ylopoListingsUrl))}
        >
          {children}
        </Button>
      </If>
    </>
  )
}

YlopoListingsButton.propTypes = propTypes

export default YlopoListingsButton
